import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index';

const routes = [
  {
    path: '/',
    component: () => import('@/components/Layout.vue'),
    children:[
      {
        path:'/',
        component: () => import('@/components/Home.vue'),
        name:'Home'
      },
      {
        path:'/shop',
        component: () => import('@/views/Shop'),
        name:'Shop'
      },
      {
        path:'/accountmanagement',
        component: () => import('@/views/AccountManagementView.vue'),
        name:'AccountManagement',
        meta: { requiresAuth: true }
      },
      {
        path:'/checkout',
        component: () => import('@/views/CheckoutView.vue'),
        name:'CheckoutView'
      },
      {
        path:'/summary',
        component: () => import('@/views/SummaryView.vue'),
        name:'SummaryView'
      },
      {
        path:'/admin',
        component: () => import('@/views/AdminView.vue'),
        name:'Admin'
      },
      {
        path:'/controlpanel',
        component: () => import('@/views/ControlPanelView.vue'),
        name:'ControlPanel',
        meta: { requiresAuth: true, role: 'admin' }
      },
      {
        path:'/useractivation',
        component: () => import('@/components/UserActivation.vue'),
        name:'UserActivation'
      },
      {
        path:'/unsubscribenewsletter',
        component: () => import('@/components/UnsubscribeNewsletter.vue'),
        name:'UnsubscribeNewsletter'
      },
      {
        path:'/passwordreset',
        component: () => import('@/components/PasswordReset.vue'),
        name:'PasswordReset'
      },
      {
        path:'/impresszum',
        component: () => import('@/views/ImpresszumView.vue'),
        name:'Impresszum'
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  }
});

// Navigation guard to check if user is authenticated before navigating to protected routes
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (to.meta.role === 'admin') {
      // Check for admin authentication
      const isAdminAuthenticated = !!store.state.adminAccessToken;
      if (isAdminAuthenticated) {
        next(); // Proceed to the route
      } else {
        next({ name: 'Admin' }); // Redirect to admin login if not authenticated
      }
    } else {
      // Check for regular user authentication
      const isAuthenticated = !!store.state.userAccessToken;
      if (isAuthenticated) {
        next(); // Proceed to the route
      } else {
        next({ name: 'Home', path:'/' }); // Redirect to Home if not authenticated
      }
    }
  } else {
    next(); // Continue navigation for routes that do not require authentication
  }
});

export default router;
